import { createContext, useContext } from 'react';
import { type LoadScriptProps, useJsApiLoader } from '@react-google-maps/api';

import { GOOGLE_MAP_API_KEY, GOOGLE_MAP_API_VERSION } from 'src/constants';
import type { GoogleMapsContextProps } from './google-maps-context.props';

const GoogleMapsContext = createContext({ isLoaded: false });

const libraries: LoadScriptProps['libraries'] = ['places', 'geometry'];

const GoogleMapsProvider = ({ children }: GoogleMapsContextProps) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAP_API_KEY,
    language: 'en',
    libraries,
    ...(GOOGLE_MAP_API_VERSION && { version: GOOGLE_MAP_API_VERSION }),
  });

  return <GoogleMapsContext.Provider value={{ isLoaded }}>{children}</GoogleMapsContext.Provider>;
};

const useGoogleMaps = () => useContext(GoogleMapsContext);

export { GoogleMapsProvider, useGoogleMaps };
